// src/utils/api.js - DEVELOPMENT MODE
import axios from 'axios';

// For local development: use http://localhost:5000/api
// For production: use /api (same-origin proxy)
const resolveApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // Default to localhost for development
  if (typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname)) {
    return 'http://localhost:5000/api';
  }
  return '/api';
};

const api = axios.create({
  baseURL: resolveApiBaseUrl(),
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('carbonx_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('carbonx_token');
      localStorage.removeItem('carbonx_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
